import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, ModalService, OrganizationService, SettingsService } from '../../services';

@Component({
    selector: 'app-dashboard-sidemenu',
    templateUrl: './dashboard-sidemenu.component.html',
    styleUrls: ['./dashboard-sidemenu.component.scss']
})
export class DashboardSidemenuComponent implements OnInit {
    constructor(
        public orgService: OrganizationService,
        public settings: SettingsService,
        public auth: AuthService,
        private router: Router,
        private modalService: ModalService
    ) {}

    ngOnInit() {
    }

    async logOut() {
        await this.auth.logOut();
        await this.router.navigate(['/']);
        window.location.reload();
    }

    navigateToFaq() {
        window.open('https://faq.vesta.app/', '_blank');
    }

    async showToolsModal() {
        const modal = await this.modalService.createModal({
            header: 'Coming Soon',
            message: 'The following features will be available soon:<br><br>FAQ<br>Rehab Guide<br>Vendor List<br>Training',
        });

        void modal.present();
    }
}
